module.exports = __webpack_public_path__ + "img/Timer.989eaf0f.svg";